import { CABIN_CLASS } from '@web-platform/shared-universal-constants/src/cabinClass';
import { ReadOnlyMap } from '@web-platform/shared-universal-utils-frontend/src/helpers/ReadOnlyMap';

import { translate } from '../translate';

import type { CabinClass } from '@web-platform/shared-universal-constants/src/cabinClass';

const cabinClassesMapPair: Array<[CabinClass, string]> = [
  [CABIN_CLASS.ECONOMY, translate('ktxt_EconomyClass')],
  [CABIN_CLASS.PREMIUM_ECONOMY, translate('ktxtCabinClassTerm_PremiumEconomy')],
  [CABIN_CLASS.BUSINESS, translate('ktxtCabinClassTerm_Business')],
  [CABIN_CLASS.FIRST, translate('ktxtCabinClassTerm_First')],
];

const cabinClassesMap = ReadOnlyMap(cabinClassesMapPair);

export const formatCabinClass = (cabinClass: CabinClass = CABIN_CLASS.ECONOMY): string =>
  cabinClassesMap.getOrDefault(cabinClass, translate('ktxt_EconomyClass'));
